var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "table",
    { staticClass: "table table-bordered", staticStyle: { width: "100%" } },
    [
      _c("thead", [
        _c("tr", [
          _c("th", { staticStyle: { "min-width": "130px" } }, [
            _vm._v(_vm._s(_vm.$t("message.date")))
          ]),
          _vm._v(" "),
          _c("th", [_vm._v(_vm._s(_vm.$t("message.cashier")))]),
          _vm._v(" "),
          _c("th", { staticClass: "text-center" }, [
            _vm._v(_vm._s(_vm.$t("apps.pos.message.possession")))
          ]),
          _vm._v(" "),
          _c("th", { staticClass: "text-center" }, [
            _vm._v(_vm._s(_vm.$t("message.transactions")))
          ]),
          _vm._v(" "),
          _c("th", { staticClass: "text-center" }, [
            _vm._v(_vm._s(_vm.$t("message.product")))
          ]),
          _vm._v(" "),
          _c("th", { staticClass: "text-center" }, [
            _vm._v(_vm._s(_vm.$t("message.new_customers")))
          ]),
          _vm._v(" "),
          _c("th", { staticClass: "text-center" }, [
            _vm._v(_vm._s(_vm.$t("message.old_customers")))
          ]),
          _vm._v(" "),
          _vm.getRoleMetadata.view.fields.net
            ? _c("th", { staticClass: "text-right" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("message.net")) + "\n      "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.getRoleMetadata.view.fields.profit
            ? _c("th", { staticClass: "text-right" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("message.profit")) + "\n      "
                )
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        [
          _vm._l(_vm.rows, function(item, index) {
            return _c("tr", { key: "row-" + index }, [
              item.index === 0
                ? _c("td", { attrs: { rowspan: item.rowspan } }, [
                    _vm._v("\n        " + _vm._s(item.date) + "\n      ")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(item.name))]),
              _vm._v(" "),
              _c("td", { staticClass: "text-center" }, [
                _vm._v(_vm._s(_vm.getNumber(item.sessionsCount)))
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "text-center" }, [
                _vm._v(_vm._s(_vm.getNumber(item.transactionsCount)))
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "text-center" }, [
                _vm._v(_vm._s(_vm.getNumber(item.productsCount)))
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "text-center" }, [
                _vm._v(_vm._s(_vm.getNumber(item.newCustomersCount)))
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "text-center" }, [
                _vm._v(_vm._s(_vm.getNumber(item.oldCustomersCount)))
              ]),
              _vm._v(" "),
              _vm.getRoleMetadata.view.fields.net
                ? _c("td", { staticClass: "text-right" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.getNumber(item.net)) +
                        "\n      "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.getRoleMetadata.view.fields.profit
                ? _c("td", { staticClass: "text-right" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.getNumber(item.profit)) +
                        "\n      "
                    )
                  ])
                : _vm._e()
            ])
          }),
          _vm._v(" "),
          _vm._l(_vm.summary, function(item, index) {
            return _c("tr", { key: "summary-" + index }, [
              index === 0
                ? _c("td", { attrs: { rowspan: _vm.summary.length } }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("apps.reports.message.total")) +
                        "\n      "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(item.name))]),
              _vm._v(" "),
              _c("td", { staticClass: "text-center" }, [
                _vm._v(_vm._s(_vm.getNumber(item.sessionsCount)))
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "text-center" }, [
                _vm._v(_vm._s(_vm.getNumber(item.transactionsCount)))
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "text-center" }, [
                _vm._v(_vm._s(_vm.getNumber(item.productsCount)))
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "text-center" }, [
                _vm._v(_vm._s(_vm.getNumber(item.newCustomersCount)))
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "text-center" }, [
                _vm._v(_vm._s(_vm.getNumber(item.oldCustomersCount)))
              ]),
              _vm._v(" "),
              _vm.getRoleMetadata.view.fields.net
                ? _c("td", { staticClass: "text-right" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.getNumber(item.net)) +
                        "\n      "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.getRoleMetadata.view.fields.profit
                ? _c("td", { staticClass: "text-right" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.getNumber(item.profit)) +
                        "\n      "
                    )
                  ])
                : _vm._e()
            ])
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1aae2f9f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1aae2f9f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/combine/ReportCashierTable.vue
// module id = null
// module chunks = 